import {certificateElementType} from "~/enums/certificateElementType";
import GridCertificateElement from "./gridCertificateElement";
import GridCellCertificateElement from "./gridCellCertificateElement";


export default class StackCertificateElement extends GridCertificateElement {
  type: certificateElementType = certificateElementType.Stack;

  vertical_cell_margin: number;
  horizontal_cell_margin: number;

  appendGridCell(iterateRowCount = true): GridCellCertificateElement {
    if (iterateRowCount){
      this.row_count++
    }
    return super.appendGridCell();
  }
  addRow(){
    this.appendGridCell()
  }

  cleanUpEmptyCells(){
    this.certificateElementsArray.forEach(gridCell  =>{
      if (!gridCell.isFirst && !gridCell.isLast && (gridCell as GridCellCertificateElement).isEmpty){
        gridCell.destroy()
      }
    })
  }

  addGridCellAtIndex(index) : GridCellCertificateElement{
    const newCell = this.appendGridCell()
    newCell.sort_order = index
    this.certificateElementHandler.updateElementPositions(this, newCell, index)
    return newCell
  }
}